import React from "react";
import "./Loader.scss";

export const Loader = (props) => (
    <div
        {...props}
        className={"loader"}
    >
        <div className="boxes">
            <div className="box">
                <div/>
                <div/>
                <div/>
                <div/>
            </div>
            <div className="box">
                <div/>
                <div/>
                <div/>
                <div/>
            </div>
            <div className="box">
                <div/>
                <div/>
                <div/>
                <div/>
            </div>
            <div className="box">
                <div/>
                <div/>
                <div/>
                <div/>
            </div>
        </div>
    </div>
);
